let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("7niKq")).then(() => parcelRequire('2O6Yo'));